angular.module('tf.controllers')
    .controller('FarmerDownloadController', function ($scope, HttpService, $timeout, HeaderService, farmers) {
            HeaderService.setName("Downloads");
            $scope.farmers = farmers;
            // $scope.download = function(){
            //     $scope.startDownload = true;
            // };

            // $timeout($scope.download, 1500);
        });
